import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f6fcf530&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6fcf530')) {
      api.createRecord('f6fcf530', component.options)
    } else {
      api.reload('f6fcf530', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f6fcf530&", function () {
      api.rerender('f6fcf530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/first/index.vue"
export default component.exports